import React from 'react';
import type { Language } from '@nordcrest/shared';
import { Spinner } from '../ui';

interface AILoadingScreenProps {
  language: Language;
}

export function AILoadingScreen({ language }: AILoadingScreenProps) {
  const messages = {
    sv: {
      title: 'Analyserar dina svar...',
      subtitle: 'Vi skapar personaliserade följdfrågor baserat på din profil',
      tip: 'Detta tar vanligtvis 5-10 sekunder',
    },
    en: {
      title: 'Analyzing your answers...',
      subtitle: 'We are creating personalized follow-up questions based on your profile',
      tip: 'This usually takes 5-10 seconds',
    },
  };

  const msg = messages[language];

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-100 rounded-full mb-6">
            <Spinner size="lg" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-3">{msg.title}</h2>
          <p className="text-gray-600 mb-4">{msg.subtitle}</p>
          <p className="text-sm text-gray-400">{msg.tip}</p>
        </div>

        {/* Animated dots */}
        <div className="flex justify-center gap-2">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-3 h-3 bg-primary-400 rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
